<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <validation-observer ref="feedbackForm">
      <b-form
        @submit.prevent=""
        @reset.prevent="resetForm"
      >
        <b-row>
          <b-col cols="12">
            <validation-provider
              #default="validationContext"
              name="Tiêu đề"
              rules="required"
            >
              <b-form-group label="Tiêu đề">
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Tiêu đề <span class="text-danger">*</span></label>
                </template>
                <b-form-input
                  v-model="frmData.title"
                  autofocus
                  :state="getValidationState(validationContext)"
                  placeholder="Tiêu đề"
                />
                <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider
              #default="validationContext"
              name="Nội dung"
              rules="required"
            >
              <b-form-group label="Nội dung">
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Nội dung <span class="text-danger">*</span></label>
                </template>
                <b-form-textarea
                  id="textarea-rows"
                  v-model="frmData.content"
                  placeholder="Nội dung"
                  :state="getValidationState(validationContext)"
                  rows="4"
                />
                <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12 text-right">
            <b-button
              type="submit"
              variant="success"
              class="ml-1 pl-2 pr-2"
              @click.prevent="validationForm"
            > Gửi</b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>
<script>
import {
  BOverlay,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BImg,
  BFormGroup,
  BLink,
  BFormInvalidFeedback,
  BForm,
  BFormTextarea,
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import {
  required, email, alphaNum, min, max,
} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import { showToast } from '@/@core/utils/utils';
import store from '@/store';

export default {
  components: {
    BOverlay,
    BImg,
    BLink,
    BFormInput,
    BFormGroup,
    BButton,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
  },
  props: {
    article_id: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const loading = ref(false)
    const blankData = {
      article_id: props.article_id,
      title: '',
      content: '',
    }

    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      frmData,
      resetfrmData,
    }
  },
  methods: {
    onSubmit() {
      this.loading = true
      store.dispatch('home/feedback', this.frmData)
        .then(response => {
          const result = response.data;
          this.loading = false
          if (result.code === 200) {
            showToast(result.message, { variant: 'success' });
            this.resetfrmData()
            this.$emit('updateFeedback');
          } else if (result.errors) {
            this.$refs.feedbackForm.setErrors(result.errors);
          } else {
            showToast(result.message);
          }
        })
    },
    validationForm() {
      this.$refs.feedbackForm.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  },
}
</script>
